var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table',{attrs:{"table-ref":"progress-table","title":"Progress","icon":"fa fa-share-alt","hide-org-badge":"","show-search":"false","url":'/actions/site/' + _vm.rowData.id + '/null/prg',"fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }